import { useEffect, useState } from "react";
import { activity } from "@/lib/api";
import { UserCircle } from "@phosphor-icons/react";

export function useDrivers(enabled) {
  const [drivers, setDrivers] = useState([]);
  useEffect(() => { if (enabled) { activity.drivers().then(setDrivers).catch(() => setDrivers([])); } }, [enabled]);
  return drivers;
}

export default function DriverFilter({ drivers, value, onChange, tid = "driver-filter" }) {
  return <label className="inline-flex items-center gap-2">
    <span className="eyebrow text-muted-foreground">Driver</span>
    <select data-testid={tid} value={value} onChange={(e) => onChange(e.target.value)}
      className="border-2 border-border focus:border-accent px-2 py-2 text-sm bg-white outline-none min-w-[10rem]">
      <option value="">All drivers</option>
      {drivers.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
    </select>
  </label>;
}

export function AddedBy({ name, tid }) {
  if (!name) return null;
  return <span data-testid={tid} className="inline-flex items-center gap-1 text-xs text-muted-foreground">
    <UserCircle size={14} weight="duotone"/> Added by <b className="text-foreground">{name}</b>
  </span>;
}
